define(["require", "exports"], function (require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.BaseOption = void 0;
    var BaseOption = (function () {
        function BaseOption(channel) {
            if (channel === void 0) { channel = ''; }
            this.baseUrl = '';
            this.isLocalHost = false;
            this.channel = '';
            this.channel = channel;
        }
        BaseOption.prototype.update = function (val) {
        };
        return BaseOption;
    }());
    exports.BaseOption = BaseOption;
});
//# sourceMappingURL=ServiceOption.js.map